<template>
  <div class="title-block">
    Êtes-vous sûr de vouloir supprimer
    <span v-if="data.length > 1">ces {{ data.length }} talents</span>
    <span class="red-color bold" v-else v-html="candidateWording" />
    ?
  </div>
  <p class="under-text">
    La suppression de talent est définitive, une fois l’action effectuée, vous
    ne pourrez plus revenir en arrière.
  </p>
  <div class="btn-container">
    <Button
      class="secondary outline"
      label="Annuler l’opération"
      @click="emits('close')"
    />
    <Button
      class="red"
      :label="`Supprimer ${data.length > 1 ? 'les talents' : 'le talent'}`"
      :loading="state.btnIsLoading"
      @click="deleteParticipants()"
    />
  </div>
</template>

<script setup>
import { computed, reactive, inject } from "vue";
import { useToast } from "vue-toastification";
import { useRoute } from "vue-router";
import { getError } from "@/composables/error.js";
import { useParticipantStore } from "@/stores/participant.js";

const participantStore = useParticipantStore();

const emitter = inject("emitter");

const toast = useToast();

const route = useRoute();

const state = reactive({
  btnIsLoading: false,
});

const emits = defineEmits(["close", "confirm"]);

const props = defineProps({
  data: {
    type: Array,
    required: true,
  },
});

const candidateWording = computed(() => {
  let candidate;

  if (props.data[0].candidate_id) {
    candidate = `${props.data[0].candidate.first_name} ${props.data[0].candidate.last_name}`;
  } else if (
    props.data[0].pending_first_name &&
    props.data[0].pending_last_name
  ) {
    candidate = `${props.data[0].pending_first_name} ${props.data[0].pending_last_name}`;
  } else {
    candidate = props.data[0].pending_email;
  }

  return candidate;
});

async function deleteParticipants() {
  state.btnIsLoading = true;

  const resp = await participantStore.deleteParticipants(
    route.params.companyId,
    route.params.spaceId,
    route.params.campaignId,
    props.data.map((elt) => elt.participant_id)
  );

  if (resp.code) {
    toast.error(getError(resp.key));
  } else {
    toast.success(
      props.data.length > 1
        ? "Les talents ont bien été supprimés de la campagne."
        : "Le talent a bien été supprimé de la campagne."
    );

    if (props.data.length > 1) emitter.emit("confirmBulk");
  }

  emits("close");

  state.btnIsLoading = false;
}
</script>
